var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoidFlockPastels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 454.67 439.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f3a6a9;}.cls-3{fill:#eee1ef;}.cls-4{fill:#e7d8eb;}.cls-5{fill:#f5b8d4;}.cls-6{fill:#e7ecf8;}.cls-7{fill:#e5e4f3;}.cls-8{fill:#fbe8f2;}.cls-9{fill:#a0afd0;}.cls-10{fill:#b9add2;}.cls-11{fill:#c2c0e1;}.cls-12{fill:#cecde8;}.cls-13{fill:#bfcde9;}.cls-14{fill:#d7d2ea;}.cls-15{fill:#d9e5f5;}.cls-16{fill:#cfd6ed;}.cls-17{fill:#e2d0e7;}.cls-18{fill:#d4cbe6;}.cls-19{fill:#d9d8ed;}.cls-20{fill:#d5d0e8;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -668.67,
    y: -450.87,
    width: 3888,
    height: 1206
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -668.67,
    y: -450.87,
    width: 3888,
    height: 1206
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -668.67,
    y: -450.87,
    width: 3888,
    height: 1206
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -668.67,
    y: -450.87,
    width: 3888,
    height: 1206
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -668.67,
    y: -450.87,
    width: 3888,
    height: 1206
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -668.67,
    y: -450.87,
    width: 3888,
    height: 1206
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -668.67,
    y: -450.87,
    width: 3888,
    height: 1206
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -668.67,
    y: -450.87,
    width: 3888,
    height: 1206
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "189.68 248.39 205.75 257.29 178.83 272.89 171.14 253.71 189.68 248.39"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "252.16 230.41 234.46 240.66 232.6 236.04 252.16 230.41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "251.25 282.52 205.75 257.29 189.68 248.39 232.6 236.04 234.46 240.66 251.25 282.52"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "220.68 331.82 182.87 347.15 182.87 325.06 202.03 321.4 204.79 322.94 204.96 323.03 220.68 331.82"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "285.8 305.4 261.6 315.21 261.08 310.13 285.8 305.4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "204.96 323.03 204.77 323.07 204.79 322.94 204.96 323.03"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "253.91 311.5 205.03 320.83 205.04 320.81 208.04 295.23 253.89 311.48 253.91 311.5"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "265.91 357.09 220.68 331.82 204.96 323.03 204.79 322.94 202.03 321.4 205.03 320.83 253.91 311.5 253.89 311.48 261.08 310.12 261.08 310.13 261.6 315.21 265.91 357.09"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "253.91 311.5 205.03 320.83 202.03 321.4 202.01 321.39 205.04 320.81 253.89 311.48 253.91 311.5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "317.78 84.64 364.89 86.59 364.22 72.72 317.78 84.64"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "364.89 86.59 382.66 119.34 364.22 72.72 364.89 86.59"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "338.02 386.83 413.1 336.08 334.15 366.36 338.02 386.83"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "348.87 360.64 393.7 343.52 348.87 296.11 348.87 360.64"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "419.17 18.78 412.84 24.28 372.81 29.65 411.16 32.11 416.68 44.8 418.78 37.17 437.8 58.8 417.92 26.45 419.17 18.78"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "43.96 345.97 54.77 363.63 16.87 367.96 16.87 342.88 43.96 345.97"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "126.41 355.41 97.66 358.71 98.5 352.22 126.41 355.41"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "98.5 352.22 97.66 358.71 89.65 420.56 54.77 363.63 43.96 345.97 98.5 352.22"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "46.67 257.42 58.23 269.62 46.11 272.33 36.87 265.62 46.67 257.42"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "93.23 306.54 79.32 296.44 81.38 294.04 93.23 306.54"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "112.84 257.42 81.38 294.04 79.32 296.44 46.11 272.33 58.23 269.62 112.84 257.42"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "235.6 86.33 213.7 99.97 207.46 82.14 222.44 77.45 235.6 86.33"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "276.6 60.96 257.09 73.08 255.07 67.59 276.6 60.96"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "270.41 109.29 235.68 86.38 235.6 86.33 222.44 77.45 255.07 67.59 257.09 73.08 270.41 109.29"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "175.65 203.16 163.62 209.48 154.1 194.4 171.36 189.92 175.65 203.16"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "204.64 187.95 208.74 180.95 208.64 180.23 229.75 174.76 204.64 187.95"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "208.74 180.95 186.17 186.08 175.56 188.48 203.35 142.94 208.64 180.23 208.74 180.95"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "208.74 180.95 204.64 187.95 182.8 225.2 175.65 203.16 171.36 189.92 171.21 189.47 175.56 188.48 186.17 186.08 208.74 180.95"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "187.19 386.65 152.82 413.62 191.32 405 187.19 386.65"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.32 405 213.06 417.58 187.3 387.12 191.32 405"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "136.01 99.81 142.22 109.13 135.61 108.96 125.41 96.82 136.01 99.81"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "171.86 109.9 158.21 109.54 159.4 106.4 171.86 109.9"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "159.48 106.17 138.53 100.26 146.04 82.21 159.48 106.17"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "159.48 106.17 159.4 106.4 158.21 109.54 152.54 124.65 142.22 109.13 136.01 99.81 135.8 99.48 138.53 100.26 159.48 106.17"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "341.75 212.68 380.06 220.17 327.27 188.89 331.63 191.47 341.75 212.68"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "327.27 188.89 290.83 243.57 341.75 212.68 331.63 191.47 327.27 188.89"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoidFlockPastels);
export default __webpack_public_path__ + "static/media/boid-flock-pastels.de61f55734b7cf2a5446ec6a78adbbe0.svg";
export { ForwardRef as ReactComponent };